module.exports = {"id":"dp2_6l1q3","text":"Managing Digital Identity","instructions":"A digital identity includes both login credentials and activity data.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":false,"options":[{"id":"dp2_6l1q3-a1","text":"True","score":1.8},{"id":"dp2_6l1q3-a2","text":"Not sure","score":0},{"id":"dp2_6l1q3-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l1q3.json
// module id = 1091
// module chunks = 41